<template>
  <v-card class="text-xs-center">
    <editStoreApprove />
  </v-card>
</template>

<script>
import editStoreApprove from "@/components/back-office/Merchant/EditStoreApprove/EditStoreApproveListTable";

export default {
  components: {
    editStoreApprove
  },
  destroyed() {
    this.$store.commit("fetchStoreApproveBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage"
      },
      {
        text: "Store approve",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storeapprove"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
